import { memo } from 'react';

import PropTypes from 'prop-types';
import { Outlet, useLocation } from 'react-router-dom';

import * as ROUTES from '#client/constants/routes';

import { AppContainer } from './AppContainer';
import { DrawerProvider } from './AppContainer/hooks/useDrawerState';

/**
 * Memoized Template switcher which rerenders only when props change
 *
 * @param {object} root0
 * @param {boolean} root0.wrap
 * @returns {import('react').ReactNode} <Outlet />
 */
const SwapTemplate = memo(({ wrap }) => {
  const staticOutlet = <Outlet />;
  if (wrap) {
    return (
      <DrawerProvider>
        <AppContainer>{staticOutlet}</AppContainer>
      </DrawerProvider>
    );
  }
  return staticOutlet;
});

SwapTemplate.displayName = 'SwapTemplate';
SwapTemplate.propTypes = {
  wrap: PropTypes.bool
};

// Paths that should NOT include page template
const nonPageTemplatePaths = [
  '/',
  '/d',
  ROUTES.callback,
  ROUTES.logout,
  '/d/account-not-found',
  '/d/account-not-found-mobile',
  '/dashboard/account-not-found',
  '/dashboard/account-not-found-mobile'
];

/**
 * Conditional Template splits the logic from the rendering
 * in order to ensure fewer redraws
 *
 * @returns {import('react').ReactElement} <SwapTemplate />
 */
export function ConditionalTemplate() {
  const { pathname } = useLocation();

  return <SwapTemplate wrap={nonPageTemplatePaths.includes(pathname) === false} />;
}

export default function Template({ children }) {
  return (
    <DrawerProvider>
      <AppContainer>{children || <Outlet />}</AppContainer>
    </DrawerProvider>
  );
}
